/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionSeasonRead
 */
export interface CompetitionSeasonRead {
    /**
     * 
     * @type {string}
     * @memberof CompetitionSeasonRead
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof CompetitionSeasonRead
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompetitionSeasonRead
     */
    league_id: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionSeasonRead
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionSeasonRead
     */
    ordinal: number;
}

/**
 * Check if a given object implements the CompetitionSeasonRead interface.
 */
export function instanceOfCompetitionSeasonRead(value: object): value is CompetitionSeasonRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('league_id' in value) || value['league_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('ordinal' in value) || value['ordinal'] === undefined) return false;
    return true;
}

export function CompetitionSeasonReadFromJSON(json: any): CompetitionSeasonRead {
    return CompetitionSeasonReadFromJSONTyped(json, false);
}

export function CompetitionSeasonReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionSeasonRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'league_id': json['league_id'],
        'id': json['id'],
        'ordinal': json['ordinal'],
    };
}

export function CompetitionSeasonReadToJSON(json: any): CompetitionSeasonRead {
    return CompetitionSeasonReadToJSONTyped(json, false);
}

export function CompetitionSeasonReadToJSONTyped(value?: CompetitionSeasonRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'league_id': value['league_id'],
        'id': value['id'],
        'ordinal': value['ordinal'],
    };
}

